module.exports = __webpack_public_path__ + "img/provider-landing-main.0edf8231.webp";